import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export interface KeyShoutTableItem extends ContentTableItem {
	data: {
		audienceGroups: { id: number; name: string }[];
	};
}

export function mapKeyShoutToContentTableItems(
	activeShouts: KeyShout[],
	draftShouts: KeyShout[]
): KeyShoutTableItem[] {
	const live = [...activeShouts]
		.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
		.map((shout, index) => ({
			id: shout.id,
			name: shout.heading,
			createdBy: shout.createdBy
				? `${shout.createdBy.firstName} ${shout.createdBy.lastName}`
				: undefined,
			lastUpdated: shout.updatedAt ?? shout.createdAt,
			isActive: true,
			order: index + 1,
			data: { audienceGroups: shout.audienceGroups ?? [] }
		}));

	const draft = draftShouts.map((shout) => ({
		id: shout.id,
		name: shout.heading,
		createdBy: shout.createdBy
			? `${shout.createdBy.firstName} ${shout.createdBy.lastName}`
			: undefined,
		lastUpdated: shout.updatedAt ?? shout.createdAt,
		isActive: false,
		data: { audienceGroups: shout.audienceGroups ?? [] }
	}));

	return [...live, ...draft];
}
